import api from './api';

export interface OpenAISettingsStatus {
  is_configured: boolean;
  source: 'database' | 'environment' | 'none';
  key_hint: string | null;
  updated_at: string | null;
}

export const openAISettingsService = {
  async getSettings(): Promise<OpenAISettingsStatus> {
    const response = await api.get<OpenAISettingsStatus>('/api/openai-settings/');
    return response.data;
  },

  async updateKey(apiKey: string): Promise<OpenAISettingsStatus> {
    const response = await api.put<OpenAISettingsStatus>('/api/openai-settings/', {
      api_key: apiKey,
    });
    return response.data;
  },

  async deleteKey(): Promise<{ message: string; fallback_to_environment: boolean }> {
    const response = await api.delete('/api/openai-settings/');
    return response.data;
  },
};
